import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { NotificationModel } from '../models/cnet-notification-model';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private _httpClient: HttpClient) { }

  getNotifications(userRequest?: boolean) {
    if (userRequest === true)
      return this._httpClient.get<Array<NotificationModel>>(`${environment.apiUrl}/notification/user-request`)
        .pipe(
          map(notifications => {
            if (notifications && notifications.length) {

              notifications.map(notification => {

                if (notification.url) {
                  notification.route = this.getRoute(notification.url)
                  notification.params = this.getRouteParams(notification.url)
                }

                return notification;
              })


              return notifications
            }

            return []
          }),
          catchError(e => of([]))
        );
    else
      return this._httpClient.get<Array<NotificationModel>>(`${environment.apiUrl}/notification`)
        .pipe(
          map(notifications => {
            if (notifications && notifications.length) {

              notifications.map(notification => {

                if (notification.url) {
                  notification.route = this.getRoute(notification.url)
                  notification.params = this.getRouteParams(notification.url)
                }

                return notification;
              })


              return notifications
            }

            return []
          }),
          catchError(e => of([]))
        );
  }



  getRoute(url: string) {
    if (url) {
      if (url.includes('?')) {
        return url.substring(0, url.indexOf('?'))
      }
      else {
        return url;
      }
    }
    return ''
  }


  getRouteParams(url) {
    if (url && url.includes('?')) {
      const queryParams = url.substring(url.indexOf('?') + 1).split('&')
      if (queryParams) {
        let angularQueryParams = {};
        queryParams.forEach(param => {
          angularQueryParams[param.split('=')[0]] = param.split('=')[1];
        });
        return angularQueryParams
      }
    }
    return null
  }

}
